import { memo, useMemo } from "react";
import { generatePath } from "react-router";

import { PATHS } from "@/routes/paths";

import type { FeatureTabItemType } from "@/components/features/_layouts";
import { FeatureIslandHeaderAndTab } from "@/components/features/_layouts";

import { Label } from "@/components/ui/label/label";

import { useInitialize } from "./use-case";

const tabArray = (hotelID: string, newRequestReservationCount: number, isHostDirectReservationAvailable: boolean) => {
	const tabArray: FeatureTabItemType[] = [
		{
			tabTitle: "検索",
			path: generatePath(PATHS.HOTEL.MANAGEMENT.RESERVATION.TOP, { hotelID }),
			tablet: true,
		},
		{
			tabTitle: "カレンダー検索",
			path: generatePath(PATHS.HOTEL.MANAGEMENT.RESERVATION.CALENDAR, { hotelID }),
		},
		{
			tabTitle: "新着リクエスト",
			tabTitleRightChildren:
				newRequestReservationCount > 0 ? (
					<Label text={newRequestReservationCount.toString()} variant="circle" />
				) : undefined,
			path: generatePath(PATHS.HOTEL.MANAGEMENT.RESERVATION.REQUEST_LIST, { hotelID }),
			tablet: true,
		},
	];

	if (isHostDirectReservationAvailable) {
		tabArray.push({
			tabTitle: "新規予約追加",
			path: generatePath(PATHS.HOTEL.MANAGEMENT.RESERVATION.ADD, { hotelID }),
		});
	}

	return tabArray;
};

type HeaderProps = {
	title: string;
	rightChildren?: React.ReactNode;
};

type Props = {
	hotelID: string;
	headerProps?: HeaderProps;
};

export const ReservationSearchHeaderAndTab = memo(({ hotelID, headerProps }: Props) => {
	const title = "予約の管理";

	const { data, isHostDirectReservationAvailable } = useInitialize({ hotelID });

	/**
	 * 新着のリクエスト予約の数
	 */
	const newRequestReservationCount: number = useMemo(() => {
		return data.reservationRequestListByMonthCount.reservations.length;
	}, [data.reservationRequestListByMonthCount.reservations]);

	return (
		<FeatureIslandHeaderAndTab
			headerProps={{ title, rightChildren: headerProps?.rightChildren }}
			tabProps={{
				tabArray: tabArray(hotelID, newRequestReservationCount, isHostDirectReservationAvailable),
			}}
		/>
	);
});
